import { ScriptedAnimation } from "slotworks/graphics/animation/scripted-animation";
import Rectangle from "slotworks/utils/geom/rectangle";
import graphicsManager from "slotworks/graphics/graphics-manager";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import Layers from "slotworks/graphics/layers/layers";
import * as TweenJS from "slotworks/utils/tween";
import Timer from "slotworks/utils/timer";
import { Shake } from "commands/shake-command";

const ANIMATED_SYMBOLS = [ "8", "TOAD" ];

enum STATES {
    SPIN = 1,
    STOP_REEL1 = 2, 
    ANIMATING_TOP_SYMBOL = 3,
    STOPPING = 4,
    CELEBRATING = 5,
    CELEBRATING_CELLS = 6,
    WAIT = 7
}

export default class IntroAnimation implements ScriptedAnimation {

    private container: PIXI.Container = null;
    private symbolsContainer: PIXI.Container = null;

    private symbols: PIXI.Sprite[][] = [];
    private matrixBackground: PIXI.Sprite;

    private lastTime: number = 0;
    private speed: number = 1;
    private state: STATES;

    private stoppingReel: number = 0;
    private dimmed: boolean = false;

    private animatingSprites: PIXI.Sprite[] = [];

    private currentSymbolAnimations: AnimatedSprite[] = [];
    private symbolAnimations: Map<string, AnimatedSprite[]> = new Map();
    private singleFrames: AnimatedSprite[] = [];
    private currentSymbolWinAnimations: AnimatedSprite[] = [];

    private timers: number[] = [];
    private tweens: TweenJS.Tween[] = [];

    private addStreaks: AnimatedSprite[] = [];
    private bottomAnticipation: PIXI.Sprite = null;
    private frames: AnimatedSprite[] = [];

    private reelStripIndexes: number[] = [0, 0, 0, 0, 0];
    private useStrip: boolean[] = [ false, false, false, false, false];
    
    private currentSymbolIndex: number = 0;
    private currentSymbolId: string = ANIMATED_SYMBOLS[0];

    private matrixShakeTween: TweenJS.Tween = null;
    private symbolsShakeTween: TweenJS.Tween = null;
    private WIN_POSITIONS: number[][] = [[0, -44], [-7, -8]]; 

    constructor(position: Rectangle) {
        this.container = new PIXI.Container();
        this.container.position.set(position.x, position.y);
        this.container.scale.set(0.5, 0.5);
        this.init();
    }

    public getContainer(): PIXI.Container {
        return this.container;
    }

    public play() {
        setTimeout(() => this.drawMask(), 1);   
        if(!this.symbolAnimations.has(this.currentSymbolId)) {
            this.symbolAnimations.set(this.currentSymbolId, []);
        }    
        if(!this.symbolAnimations.has(this.currentSymbolId + "_win")) {
            this.symbolAnimations.set(this.currentSymbolId + "_win", []);
        } 
        this.start();
    }

    public start() {
        this.state = STATES.SPIN;
        this.stoppingReel = 0;
        this.setDim(false);
        this.timers.push(Timer.setTimeout(() => {
            this.state = STATES.STOP_REEL1;
        }, 2000));
    }

    public stop() {

    }

    public update(time: number) {
        if(!this.lastTime) {
            this.lastTime = time;
            return;
        }
        let diff = time - this.lastTime;
        if(diff > 20) diff = 20; 
        this.lastTime = time;
        if(this.state >= STATES.SPIN && this.state <= STATES.STOPPING) {
            const distance = diff * this.speed;
            for(let i = this.stoppingReel; i < this.symbols.length; i++) {
                if(this.stoppingReel == i && this.reelStripIndexes[i] >= STRIPS[this.currentSymbolIndex][i].length) {
                    this.stoppingReel++;                    
                    this.reelStripIndexes[i] = 0;
                    if(i + 1 < this.symbols.length) {
                        this.reelStripIndexes[i + 1] = 0;
                    }
                    this.fixPositions(i);
                    this.setAnticipations(i);
                    if(this.stoppingReel == 1) {
                        this.setDim();
                        this.startAnimation();
                        this.state = STATES.ANIMATING_TOP_SYMBOL;
                    }
                    if(this.stoppingReel >= this.symbols.length) {
                        this.timers.push(Timer.setTimeout(() => this.startSingleFrameAnimations(), 4000));
                    }
                } else {
                    for(let j = 0; j < this.symbols[i].length; j++) {
                        const symbol = this.symbols[i][j];
                        symbol.y += distance;
                        if(symbol.y >= BOTTOMY[i]) {
                            symbol.y = YOFFSETS[i] + (symbol.y - BOTTOMY[i]);
                            if((this.state == STATES.STOP_REEL1 || this.state == STATES.STOPPING) && this.stoppingReel == i && this.reelStripIndexes[i] < STRIPS[this.currentSymbolIndex][i].length) {
                                symbol.texture = graphicsManager.getTexture(STRIPS[this.currentSymbolIndex][i][this.reelStripIndexes[i]]);
                                this.dimSymbol(symbol, STRIPS[this.currentSymbolIndex][i][this.reelStripIndexes[i]] != this.currentSymbolId);
                                this.reelStripIndexes[i]++;
                            } else {
                                if(this.useStrip[i]) {
                                    symbol.texture = graphicsManager.getTexture(STRIPS[this.currentSymbolIndex][i][this.reelStripIndexes[i]]);                                    
                                    this.dimSymbol(symbol, STRIPS[this.currentSymbolIndex][i][this.reelStripIndexes[i]] != this.currentSymbolId);
                                    this.reelStripIndexes[i]++;
                                    if(this.reelStripIndexes[i] >= STRIPS[this.currentSymbolIndex][i].length) this.reelStripIndexes[i] = 0;
                                } else {
                                    const type = TYPES[Math.floor(Math.random() * TYPES.length)];
                                    symbol.texture = graphicsManager.getTexture(type);
                                    this.dimSymbol(symbol, this.dimmed && type != this.currentSymbolId);
                                }
                            }
                            
                        }
                    }
                }
            }
        }
    }

    public destroy() {
        this.cleanTimers();
        this.cleanTweens();
        this.stopShakes();        
        this.container.removeChild(this.symbolsContainer);
        this.container.parent.removeChild(this.container);
        this.symbolsContainer.destroy({children: true});
        while(this.container.children.length) {
            const obj = this.container.children[this.container.children.length - 1];
            if(obj instanceof AnimatedSprite) {
                obj.stop();
            }
            this.container.removeChild(obj);
            obj.destroy();
        }
        this.container.destroy({children: true});
        this.container = null;
    }

    private init() {
        this.matrixBackground = graphicsManager.createSprite("MatrixBackground/288_reelbg");
        const blackBackground = graphicsManager.createSprite("MatrixBackground/Reel_shadow");
        this.container.addChild(blackBackground);
        blackBackground.position.set(50, 70);
        this.container.addChild(this.matrixBackground);
        this.matrixBackground.x = 80;
        this.matrixBackground.y = 120;
        this.symbolsContainer = new PIXI.Container();
        this.container.addChild(this.symbolsContainer);
        const matrixForeground = graphicsManager.createSprite("MatrixForeground/288_reelframe");
        this.container.addChild(matrixForeground);
        matrixForeground.x = 76;
        matrixForeground.y = 88;
        for (let i = 0; i < dimensions.length; i++) {
            this.symbols[i] = [];
            for (let j = 0; j < dimensions[i]; j++) {
                this.symbols[i][j] = graphicsManager.createSprite(TYPES[Math.floor(Math.random() * TYPES.length)]);
                this.symbols[i][j].position.set(124 + i * 243, YOFFSETS[i] + j * 182);
                this.symbolsContainer.addChild(this.symbols[i][j]);
            }
        }
    }

    private stopFrames() {
        for(let frame of this.frames) {
            frame.stop();
            frame.parent.removeChild(frame);
            frame.destroy();
        }
        this.frames.length = 0;
    }

    private stopAnticipations() {
        for(let anim of this.currentSymbolAnimations) {
            anim.stop();
            anim.visible = false;
        }
    }

    private resetAnimations() {
        const stack = this.symbolAnimations.get(this.currentSymbolId)
        for(let anim of this.currentSymbolAnimations) {
            anim.stop();
            anim.visible = false;
            stack.push(anim);
        }
        this.currentSymbolAnimations.length = 0;

        const winstack = this.symbolAnimations.get(this.currentSymbolId + "_win")
        for(let anim of this.currentSymbolWinAnimations) {
            anim.stop();
            anim.visible = false;
            winstack.push(anim);
        }
        this.currentSymbolWinAnimations.length = 0;

        this.bottomAnticipation.visible = false;
        for(let streak of this.addStreaks) {
            streak.stop();
            streak.visible = false;
        }
        this.stopFrames();
    }

    private restart() {
        this.resetAnimations();
        this.showAll();

        this.currentSymbolIndex = ANIMATED_SYMBOLS.indexOf(this.currentSymbolId) + 1;
        if(this.currentSymbolIndex >= ANIMATED_SYMBOLS.length) this.currentSymbolIndex = 0;
        this.currentSymbolId = ANIMATED_SYMBOLS[this.currentSymbolIndex];
        if(!this.symbolAnimations.has(this.currentSymbolId)) {
            this.symbolAnimations.set(this.currentSymbolId, []);
        }
        if(!this.symbolAnimations.has(this.currentSymbolId + "_win")) {
            this.symbolAnimations.set(this.currentSymbolId + "_win", []);
        }
        this.stoppingReel = 0;
        this.dimmed = false;
        this.matrixBackground.alpha = 1;
        for(let i = 0; i < this.reelStripIndexes.length; i++) {
            this.reelStripIndexes[i] = 0;
        }
        for(let i = 0; i < this.useStrip.length; i++) {
            this.useStrip[i] = false;
        }
        this.start();
    }

    private drawMask() {
        const mask = new PIXI.Graphics();
        mask.beginFill(0x00ffff);
        for (let i = 1; i <= 3; i++) {
            const position = Layers.Prompts.getPosition("mask" + i);
            mask.drawRect(position.x + Layers.Prompts.container.x, position.y + Layers.Prompts.container.y, position.width, position.height);
        }
        this.symbolsContainer.mask = mask;
    }

    private setDim(dim: boolean = true) {
        this.dimmed = dim;
        for(let i = 1; i < this.symbols.length; i++) {
            for(let j = 0; j < this.symbols[i].length; j++) {
                if(dim) {
                    this.symbols[i][j].tint = 0x222222;
                    this.symbols[i][j].alpha = 0.8;
                } else {
                    this.symbols[i][j].tint = 0xffffff;
                    this.symbols[i][j].alpha = 1;
                }
            }
        }
        this.matrixBackground.alpha = dim ? 0.9 : 1;
    }

    private dimSymbol(symbol: PIXI.Sprite, dim: boolean = true) {
        if(this.stoppingReel == 0) return;
        if(dim) {
            symbol.tint = 0x222222;
            symbol.alpha = 0.8;
        } else {
            symbol.tint = 0xffffff;
            symbol.alpha = 1;
        }
    }

    private startSingleFrameAnimations() {
        this.state = STATES.WAIT;
        let count = 0;
        this.stopFrames();
        this.stopAnticipations();
        this.startWinAnimations();
        for(let reel = 0; reel < 5; reel++) {
            for(let i = 0; i < WININGS[this.currentSymbolIndex][reel].length; i++) {
                if(WININGS[this.currentSymbolIndex][reel][i]) {
                    if(!this.singleFrames[count]) {
                        this.singleFrames[count] = graphicsManager.createAnimation("anticframe1");
                        this.container.addChild(this.singleFrames[count]);
                    } else {
                        this.bringToTop(this.singleFrames[count]);
                    }
                    this.singleFrames[count].visible = true;
                    this.singleFrames[count].position.set(102 + reel * 243, YOFFSETS[reel] - 30 + (i + 1) * 182);
                    this.singleFrames[count].gotoAndPlay(0);
                    count++;
                }
            }
        }
        this.timers.push(Timer.setTimeout(() => {
            this.stopSingleFrameAnimations();
        }, 19 * (1000/16)));
        this.timers.push(Timer.setTimeout(() => this.restart(), 4000));
    }

    private startWinAnimations() {
        for(let reel = 0; reel < 5; reel++) {
            for(let i = 0; i < WININGS[this.currentSymbolIndex][reel].length; i++) {
                if(WININGS[this.currentSymbolIndex][reel][i]) {
                    const saved = this.symbolAnimations.get(this.currentSymbolId + "_win").pop();
                    const anim = saved ? saved : graphicsManager.createAnimation(this.currentSymbolId + "_win");
                    anim.visible = true;
                    if(saved) this.bringToTop(anim);  
                    else this.container.addChild(anim);
                    anim.position.set(124 + reel * 243 + this.WIN_POSITIONS[this.currentSymbolIndex][0], YOFFSETS[reel] + (i + 1) * 182 + this.WIN_POSITIONS[this.currentSymbolIndex][1]);
                    anim.loop = false;
                    anim.gotoAndPlay(0);
                    this.currentSymbolWinAnimations.push(anim);
                }
            }
        }
    }

    private stopSingleFrameAnimations() {
        for(let anim of this.singleFrames) {
            anim.stop();
            anim.visible = false;
        }
    }

    private setAnticipations(reel: number) {
        for(let i = 0; i < WININGS[this.currentSymbolIndex][reel].length; i++) {
            if(WININGS[this.currentSymbolIndex][reel][i]) {
                const saved = this.symbolAnimations.get(this.currentSymbolId).pop();
                const anim = saved ? saved : graphicsManager.createAnimation(this.currentSymbolId + "_antic");
                anim.visible = true;
                anim.loop = true;
                anim.position.set(124 + reel * 243, YOFFSETS[reel] + (i + 1) * 182);
                this.container.addChild(anim);
                if(this.currentSymbolAnimations.length > 0) 
                    anim.gotoAndPlay(this.currentSymbolAnimations[0].currentFrame);
                else
                    anim.play();
                this.currentSymbolAnimations.push(anim);
            }
        }
        for(let i = 0; i < FRAMES[this.currentSymbolIndex][reel].length; i++) {
            const frame = graphicsManager.createAnimation(FRAMES[this.currentSymbolIndex][reel][i].type);
            frame.loop = true;
            this.container.addChild(frame);
            frame.position.set(FRAMES[this.currentSymbolIndex][reel][i].x + 6, FRAMES[this.currentSymbolIndex][reel][i].y + 2);
            if(this.frames.length > 0)
                frame.gotoAndPlay(this.frames[0].currentFrame)
            else
                frame.play();
            this.frames.push(frame);
        }
    }

    private startAnimation() {
        for(let i = 4; i >= 0; i--) {
            if(!this.animatingSprites[i]) {
                this.animatingSprites[i] = graphicsManager.createSprite(this.currentSymbolId); 
                if(i == 0) {
                    this.container.addChild(this.animatingSprites[i])
                } else {          
                    this.symbolsContainer.addChild(this.animatingSprites[i]);
                }
                this.animatingSprites[i].anchor.set(0.5, 0.5);
                const frame = graphicsManager.createSprite("addframe");
                frame.anchor.set(0.5, 0.5);
                this.animatingSprites[i].addChild(frame);
            } else {
                this.animatingSprites[i].texture = graphicsManager.getTexture(this.currentSymbolId);
                this.bringToTop(this.animatingSprites[i]);
            }
            if(i == 0) {
                this.animatingSprites[i].position.set(124 + this.animatingSprites[0].width * 0.5, 305 + this.animatingSprites[0].height * 0.5);  
                this.animatingSprites[i].visible = true;              
            } else {
                this.animatingSprites[i].visible = false;
            }
        }
        this.moveToPosition(0);
    }

    private moveToPosition(position: number) {
        this.shakeMatrix();
        this.shakeSymols();
        const tween = new TweenJS.Tween(this.animatingSprites[0])
        .to({x: POSITIONS[position].x, y: [POSITIONS[position].y - 100, POSITIONS[position].y] } , 600)
        .interpolation(TweenJS.Interpolation.Bezier)
        .onComplete(() => {
            this.cleanTweens();
            this.cleanTimers();
            this.animatePosition(position);
        });
        this.tweens.push(tween);
        tween.start();
        this.animatingSprites[0].scale.set(1, 1);
        this.tweens.push(new TweenJS.Tween(this.animatingSprites[0].scale)
        .to({x: 1.5, y: 1.5}, 280)
        .yoyo(true)
        .repeat(1)
        .start());
    }

    private animatePosition(position: number) {
        this.anticipationOnReel(position + 1);
        this.underAnimation(position);

        if(position < POSITIONS.length - 1) {
            this.timers.push(Timer.setTimeout(() => this.moveToPosition(position + 1), 1600));
        } else {
            this.timers.push(Timer.setTimeout(() => {
                this.animatingSprites[0].visible = false;
                this.state = STATES.STOPPING;
                this.stopShakes();
            }, 1000));
        }
        
    }

    private anticipationOnReel(reel: number) {
        if(!this.addStreaks.length) {
            this.addStreaks[0] = graphicsManager.createAnimation("add_streak");
            this.addStreaks[1] = graphicsManager.createAnimation("add_streak");
            this.symbolsContainer.addChild(this.addStreaks[0]);
            this.symbolsContainer.addChild(this.addStreaks[1]);
            this.addStreaks[0].loop = true;
            this.addStreaks[1].loop = true;
            this.bottomAnticipation = graphicsManager.createSprite("StackAddForeground-stackadd/reel5_add_bottom");
            this.container.addChild(this.bottomAnticipation);
        }
        this.addStreaks[0].visible = true;
        this.addStreaks[1].visible = true;
        this.addStreaks[0].position.set(90 + reel * 243, YOFFSETS[reel] + 182);
        this.addStreaks[1].position.set(124 + reel * 243 + 140, YOFFSETS[reel] + 182);
        this.addStreaks[0].gotoAndPlay(0); 
        this.addStreaks[1].gotoAndPlay(0);
        this.bottomAnticipation.position.set(100 + reel * 243, YOFFSETS[reel] + (dimensions[reel] - 1.21) * 182);
        this.bottomAnticipation.visible = true;
        
        this.timers.push(Timer.setTimeout(() => {
            this.addStreaks[0].stop();
            this.addStreaks[1].stop();
            this.addStreaks[0].visible = false;
            this.addStreaks[1].visible = false;
            this.bottomAnticipation.visible = false;
        }, 1500));
    }

    private stackAddSymbolRepeats: number = 7;
    private stackAddSymolDownMotion: number = 160;
    private underAnimation(position: number) {
        this.animatingSprites[1].visible = true;
        this.animatingSprites[1].position.set(this.animatingSprites[0].x, this.animatingSprites[0].y);
        this.animatingSprites[1].scale.set(0.9, 0.9)
        this.tweens.push(new TweenJS.Tween(this.animatingSprites[1])
        .to({y: this.animatingSprites[0].y + this.animatingSprites[0].height * 0.8}, this.stackAddSymolDownMotion)
        .repeat(this.stackAddSymbolRepeats)
        .start());
        this.tweens.push(new TweenJS.Tween(this.animatingSprites[1].scale)
        .to({x: 1.1, y: 1.1}, this.stackAddSymolDownMotion)
        .repeat(this.stackAddSymbolRepeats)
        .onComplete(() => { this.animatingSprites[1].visible = false })
        .start());
        this.bringToTop(this.animatingSprites[4]);
        this.bringToTop(this.animatingSprites[3]);
        this.bringToTop(this.animatingSprites[2]);
        this.bringToTop(this.animatingSprites[1]);
        this.timers.push(Timer.setTimeout(() => {
            this.animatingSprites[2].visible = true;
            this.animatingSprites[2].position.set(this.animatingSprites[0].x, this.animatingSprites[0].y + this.animatingSprites[0].height * 0.8);
            this.animatingSprites[2].scale.set(1, 1)
            this.tweens.push(new TweenJS.Tween(this.animatingSprites[2])
            .to({y: this.animatingSprites[0].y + this.animatingSprites[0].height * 1.5}, this.stackAddSymolDownMotion)
            .repeat(this.stackAddSymbolRepeats + 1)
            .onComplete(() => { this.animatingSprites[2].visible = false })
            .start());
        }, this.stackAddSymolDownMotion));
        this.timers.push(Timer.setTimeout(() => {
            this.useStrip[position + 1] = true;
            this.animatingSprites[3].visible = true;
            this.animatingSprites[3].position.set(this.animatingSprites[0].x, this.animatingSprites[0].y + this.animatingSprites[0].height * 1.5);
            this.animatingSprites[3].scale.set(0.92, 0.92);
            const multiplier = position <= 1 ? 2 : 3;
            this.tweens.push(new TweenJS.Tween(this.animatingSprites[3])
            .to({y: this.animatingSprites[0].y + this.animatingSprites[0].height * multiplier}, this.stackAddSymolDownMotion)
            .repeat(this.stackAddSymbolRepeats + 1)
            .onComplete(() => {
                this.animatingSprites[3].visible = false;
            })
            .start());
        }, 2*this.stackAddSymolDownMotion));
        this.timers.push(Timer.setTimeout(() => {
            this.useStrip[position + 1] = true;
            this.animatingSprites[4].visible = true;
            this.animatingSprites[4].position.set(this.animatingSprites[0].x, this.animatingSprites[0].y + this.animatingSprites[0].height * 2);
            this.animatingSprites[4].scale.set(0.92, 0.92);
            const multiplier = 4;
            this.tweens.push(new TweenJS.Tween(this.animatingSprites[4])
            .to({y: this.animatingSprites[0].y + this.animatingSprites[0].height * multiplier}, this.stackAddSymolDownMotion)
            .repeat(this.stackAddSymbolRepeats + 1)
            .onComplete(() => {
                this.animatingSprites[4].visible = false;
            })
            .start());
        }, 3*this.stackAddSymolDownMotion));
    }

    private showAll() {
        for(let i = 0; i < this.symbols.length; i++) {
            for(let j = 0; j < this.symbols[i].length; j++) {
                this.symbols[i][j].visible = true;
            }
        }
    }

    private fixPositions(reel: number) {
        for(let symbol of this.symbols[reel]) {
            const index = Math.floor((symbol.y - YOFFSETS[reel])/ 182);
            symbol.y = YOFFSETS[reel] + index * 182; 

            if(reel == 0 || index < 1 || index > dimensions[reel] - 2) {
                symbol.visible = false;
            }
        } 
    }

    private bringToTop(sprite: PIXI.Sprite | AnimatedSprite) {
        const parent = sprite.parent;
        parent.removeChild(sprite);
        parent.addChild(sprite);
    }

    private shakeMatrix() {
        if(this.matrixShakeTween) {
            this.matrixShakeTween.stop();
            TweenJS.remove(this.matrixShakeTween);
        }
        this.matrixShakeTween = Shake(this.container, 50 + Math.random() * 20, 6 + Math.random() * 4, 1 + Math.random() * 4, 50);
    }

    private shakeSymols() {
        if(this.symbolsShakeTween) {
            this.symbolsShakeTween.stop();
            TweenJS.remove(this.symbolsShakeTween);
        }
        this.symbolsShakeTween = Shake(this.symbolsContainer, 50, 4 + Math.random() * 6, 2 + Math.random() * 4, 50);
    }

    private stopShakes() {
        if(this.matrixShakeTween) {
            this.matrixShakeTween.stop();
            TweenJS.remove(this.matrixShakeTween);
        }
        if(this.symbolsShakeTween) {
            this.symbolsShakeTween.stop();
            TweenJS.remove(this.symbolsShakeTween);
        }
    }

    private cleanTweens() {
        for(let tween of this.tweens) {
            tween.stop();
            TweenJS.remove(tween);
        }
        this.tweens.length = 0;
    }

    private cleanTimers() {
        for(let timer of this.timers) {
            Timer.clearTimeout(timer);
        }
        this.timers.length = 0;
    }
}

const FRAMES = [[
    [
        {
            type: "anticframe2", x: 100, y: 270
        }
    ],
    [
        {
            type: "anticframe3", x: 100 + 243, y: 180
        }
    ],
    [
        {
            type: "anticframe3", x: 100 + 243 * 2, y: 180
        }
    ],
    [
        {
            type: "anticframe3", x: 100 + 243 * 3, y: 97
        }
    ],
    [
        {
            type: "anticframe3", x: 100 + 243 * 4, y: 97
        }
    ]
],
[
    [
        {
            type: "anticframe2", x: 100, y: 270
        }
    ],
    [
        {
            type: "anticframe3", x: 100 + 243, y: 180
        }
    ],
    [
        {
            type: "anticframe2", x: 100 + 243 * 2, y: 180
        }
    ],
    [
        {
            type: "anticframe2", x: 100 + 243 * 3, y: 97
        }
    ],
    [
        {
            type: "anticframe4", x: 100 + 243 * 4, y: 97
        }
    ]
]];

const dimensions = [
    4, 5, 5, 6, 6
];
const YOFFSETS = [
    305 - 182, 215 - 182, 215 - 182, 129 - 182, 129 - 182
]

const BOTTOMY = [
    305 + 3 * 182, 
    215 + 4 * 182,
    215 + 4 * 182,
    132 + 5 * 182,
    132 + 5 * 182
]

const TYPES = [
    "9", "10", "A", "J", "K", "Q", "8", "COIN", "GOLD", "TOAD", "MONEYP", "9", "10", "A", "J", "K", "Q", "9", "10", "A", "J", "K", "Q", "9", "10", "A", "J", "K", "Q"
];

const WININGS = [[
    [true, true],
    [true, true, true],
    [true, true, true],
    [true, true, true, false],
    [true, true, true, false]
],
[
    [true, true],
    [true, true, true],
    [true, true, false],
    [true, true, false, false],
    [true, true, true, true]
]]

const STRIPS = [
    [[ "A", "J", "8", "8", "9", "Q", "8", "8", "8", "8"],
    [ "A", "J", "8", "8", "9", "Q", "8", "8", "8", "8"],
    [ "A", "J", "8", "8", "9", "Q", "8", "8", "8", "8"],
    [ "A", "J", "8", "8", "9", "Q", "8", "8", "8", "8"],
    [ "A", "J", "8", "8", "9", "Q", "8", "8", "8", "8"]],

    [[ "A", "J", "TOAD", "TOAD", "A", "10", "TOAD", "TOAD", "TOAD", "TOAD"],
    [ "K", "J", "TOAD", "A", "9", "Q", "TOAD", "TOAD", "TOAD", "A"],
    [ "J", "TOAD", "TOAD", "J", "9", "Q", "10", "TOAD", "TOAD", "TOAD"],
    [ "K", "J", "10", "TOAD", "9", "Q", "K", "TOAD", "TOAD", "J"],
    [ "A", "TOAD", "TOAD", "J", "9", "TOAD", "TOAD", "TOAD", "TOAD", "9"]]
];

const POSITIONS = [
    {x: 124 + 1.5 * 243, y: 215},
    {x: 124 + 2.5 * 243, y: 215},
    {x: 124 + 3.5 * 243, y: 132},
    {x: 124 + 4.5 * 243, y: 132}
];



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/animations/intro-animation.ts